import { Injectable } from "@angular/core";
import { BaseDataResponse, BaseEntitiesResponse, GenericListEntity, Notification, NotificationListParams, NotificationView } from '@base/entities/BaseEntities';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { BaseEndpointCRUD } from '@m4u-angular/base/endpoint/BaseEndpointCRUD';
import { Observable } from "rxjs";
import { APIGatewayService } from "../gateway/APIGateway.service";
import { EnumNotificationDeliveryOptions } from '@core/framework/sysenums.enum';


@Injectable()
export class NotificationEndpoint extends BaseEndpointCRUD<Notification> {
    //Constructor
    constructor(api: APIGatewayService) {
        super("Notification", api);
    }
    
    public GetNotificationsReport(Params: NotificationListParams, options: DataLoadOptions): Observable<BaseEntitiesResponse<NotificationView>> {
        return this.api.ExecutePostAction(this.ControllerName, 'GetNotificationsReport', Params, options?.GetLoadOptions());
    }
    public GetRelevantDeliveryOptions(): Observable<BaseDataResponse<EnumNotificationDeliveryOptions[]>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetRelevantDeliveryOptions', { });
    }
    public GetNotificationsTemplates(): Observable<BaseEntitiesResponse<GenericListEntity>> {
        return this.api.ExecuteGetAction(this.ControllerName, 'GetNotificationsTemplates', { });
    }
}
